import useLanguage from './useLanguage';

export interface ILocalizedString {
	languageID: string;
	text: string;
}

const usePreferredTranslation = () => {
	const language = useLanguage();

	return {
		translate: (value: ILocalizedString[]) =>
			(value.find((variant) => variant.languageID === language.id) ?? value[0])?.text,
	};
};

export default usePreferredTranslation;
